import { Form, FormInstance } from 'antd'
import React from 'react'
import { DeliverySubscription } from '../../../types/deliverySubscription/DeliverySubscription'
import { useDeliverySubscriptionForm } from '../hooks/useDeliverySubscriptionForm'
import { DeliverySubscriptionFormData } from '../types'
import SharedSubscriptionFields from './SharedSubscriptionFields'

const INITIATOR_OPTIONS = ['monthly', 'periodLock', 'manual'] as const

interface AccountorScorecardSubscriptionFormProps {
  form: FormInstance<DeliverySubscriptionFormData>
  deliverySubscription?: DeliverySubscription
}

const AccountorScorecardSubscriptionForm: React.FC<AccountorScorecardSubscriptionFormProps> = ({
  form,
  deliverySubscription
}) => {
  const { selectableCompanies, selectableUsers } = useDeliverySubscriptionForm(form, deliverySubscription)

  return (
    <Form
      onValuesChange={changedValue => {
        if (changedValue.companyId) {
          form.resetFields(['userId', 'reportId', 'params', 'recipients'])
        }
      }}
      form={form}
      layout="vertical"
      className="delivery-subscription-form"
    >
      <SharedSubscriptionFields
        form={form}
        initiatorOptions={INITIATOR_OPTIONS}
        selectableCompanies={selectableCompanies}
        selectableUsers={selectableUsers}
      />
    </Form>
  )
}

export default AccountorScorecardSubscriptionForm
